import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { EmailAddress } from 'src/app/models/email-address';
import { Rights } from 'src/app/models/enums/rights';
import { EmailAddressesService } from 'src/app/services/emailAddress.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-email-addresses-list',
    templateUrl: './email-addresses-list.component.html',
    styleUrls: ['./email-addresses-list.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class EmailAddressesListComponent extends DefaultListComponent<EmailAddress> implements OnInit {
    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param emailAddressesService : Service de gestion des adresses email.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private emailAddressesService: EmailAddressesService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        // Specifie des colonnes en fonction des droits utilisateurs
        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnDefinition('address', 'Adresse mail', ColumnType.Text, FilterType.Text, 2, 70, true),
                new ColumnDefinition('isActive', 'Active', ColumnType.Boolean, FilterType.Boolean, 3, 10, true),
                new ColumnDefinition('sendingEnabled', 'Envoi autorisé ', ColumnType.Boolean, FilterType.Boolean, 4, 10, true),
            ];
        } else {
            this.tableConfig = [
                new ColumnDefinition('address', 'Adresse mail', ColumnType.Text, FilterType.Text, 2, 75, true),
                new ColumnDefinition('isActive', 'Active', ColumnType.Boolean, FilterType.Boolean, 3, 10, true),
                new ColumnDefinition('sendingEnabled', 'Envoi autorisé ', ColumnType.Boolean, FilterType.Boolean, 4, 10, true),
            ];
        }

        // Spécifie les éléments du menu contextuel en fonction des droits utilisateur
        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.EmailAddressCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.EmailAddressEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.EmailAddressDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.emailAddressesService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('address', 'asc'));
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<EmailAddress>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de duplication.
            this.itemDuplicated.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer l'adresse mail '${event.context.address}'.`, event.context);
        }
    }
}
